import { createComponent } from '@mtfe/sweet';
import { lazyLoadImg, eventBus } from '@mtfe/sweet-utils';
import tpl from './dom.html';
import style from './style.less';
import { COUPON_STATUS } from '../constants/index';
import componentUtils from '../utils/index';
import ACoupon from './CouponType/ACoupon/script';
import MultipleCoupon from './CouponType/MultipleCoupon/script';

const { getGiftEventName, Describe } = componentUtils;
const { DEFAULT_DATA_SRC } = lazyLoadImg;

const COMPONENT_ID = 'waimai_o7gp9nj2';
const describePoiInfoG = new Describe('PoiInfoG', COMPONENT_ID);

describePoiInfoG.setSubComponent('Coupon', ACoupon.describe);
describePoiInfoG.setSubComponent('MultipleCoupon', MultipleCoupon.describe);

const PoiInfoG = (props) => {
    const {
        poiInfo,
        isLazyLoadImg,
        onPoiInfoClick,
        itemIndex = -1,
        renderCoupon = '',
        onCouponBtnClick,
        showCoupon = true,
        onOtherDetailClick,
    } = props || {};

    const renderRules = {
        oneCoupon: ACoupon,
        multipleCoupon: MultipleCoupon,
        default: ACoupon,
    };

    let ugc = '';
    const poi_label_map_10 =
        poiInfo.poiBaseInfo.poi_label_map && poiInfo.poiBaseInfo.poi_label_map['10'];
    if (poi_label_map_10 && poi_label_map_10[0]) {
        ugc = (poi_label_map_10[0].content || '').replace(/^“+|”+$/gm, '');
        if (ugc.length > 15) {
            ugc = ugc.substring(0, 15) + '...';
        }
    }

    const renderCouponFunc = renderRules[renderCoupon] || renderRules['default'];
    const data = {
        itemIndex,
        DEFAULT_DATA_SRC,
        poiInfo,
        isLazyLoadImg,
        ugc,
        couponInfo: renderCouponFunc({
            onCouponBtnClick,
            showCoupon,
            poiInfo,
            onOtherDetailClick,
        }),
        shopLabelIcon:
            (poiInfo.poiBaseInfo &&
                poiInfo.poiBaseInfo.poi_label_map &&
                poiInfo.poiBaseInfo.poi_label_map['3'] &&
                poiInfo.poiBaseInfo.poi_label_map['3'][0]['label_icon']) ||
            '',
    };
    if (poiInfo.giftInfo) {
        const { giftInfo, poi_id_str } = poiInfo;
        const { gift_id: giftId } = giftInfo;
        const eventName = getGiftEventName(giftId);
        // 使用on才能更改所有与券相关的所有商家
        eventBus.$on(eventName, (newStatus) => {
            const selector = `[data-gift-id=gift-id${giftId}${poi_id_str}]`;
            const btnDomList = Array.from(document.querySelectorAll(selector));

            if (btnDomList.length) {
                btnDomList.forEach((btnDom) => {
                    if (newStatus === COUPON_STATUS.STATUS_NEW) {
                        btnDom.innerText = '立即领取';
                        giftInfo.status = COUPON_STATUS.STATUS_NEW;
                    } else if (newStatus === COUPON_STATUS.STATUS_RECEIVED) {
                        btnDom.innerText = '立即使用';
                        giftInfo.status = COUPON_STATUS.STATUS_RECEIVED;
                    }
                });
            }
        });
    }
    const events = {
        onPoiInfoClick: () => {
            if (onPoiInfoClick) {
                onPoiInfoClick(poiInfo);
            }
            return false;
        },
    };
    const component = createComponent(tpl, { data, style }, events);

    return component;
};
PoiInfoG.describe = describePoiInfoG;

export default PoiInfoG;
